import instance from './instance';

export default (couponId) =>
  instance()
    .delete(`/coupons/${couponId}`)
    .then(() => true);
